export const SET_MENU = 'MENU/SET_MENU'
export const SET_MENUS = 'MENU/SET_MENUS'
